import React, { useState, useRef, useEffect } from 'react';
import { FaSearch, FaFilter } from 'react-icons/fa';
import FilterDropdown from './FilterDropdown';

const SearchBar = ({
    isHome,
    searchQuery,
    setSearchQuery,
    enableFilters = false,
    filters = {},
    setFilters,
    onSearch,
    categories = [],
    isCategory = false,
}) => {
    const [showFilters, setShowFilters] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const searchContainerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setShowFilters(false);
            }
        };

        if (showFilters) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showFilters]);

    const generateSuggestions = (query) => {
        const lowerQuery = query.toLowerCase();
        const suggestions = [];
        categories.forEach((category) => {
            if (category.name.toLowerCase().includes(lowerQuery)) {
                suggestions.push({ type: 'main', name: category.name });
            }
            category.subcategories.forEach((sub) => {
                if (sub.toLowerCase().includes(lowerQuery)) {
                    suggestions.push({ type: 'sub', main: category.name, sub: sub });
                }
            });
        });
        return suggestions;
    };

    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        if (isCategory && query) {
            setSuggestions(generateSuggestions(query));
        } else {
            setSuggestions([]);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setShowFilters(false);
            onSearch(searchQuery, filters);
        }
    };

    const handleSearchClick = () => {
        setShowFilters(false);
        onSearch(searchQuery, filters);
    };

    const handleSuggestionClick = (suggestion) => {
        if (suggestion.type === 'main') {
            setFilters({ ...filters, category: suggestion.name, subcategory: '' });
            onSearch('', { ...filters, category: suggestion.name, subcategory: '' });
        } else {
            setFilters({ ...filters, category: suggestion.main, subcategory: suggestion.sub });
            onSearch('', { ...filters, category: suggestion.main, subcategory: suggestion.sub });
        }
        setSearchQuery('');
        setSuggestions([]);
    };

    const appliedFiltersCount = Object.entries(filters)
        .filter(([_, value]) => value && (Array.isArray(value) ? value.length > 0 : true))
        .length;

    return (
        <div className={isHome ? 'topBar' : 'topBar2'}>
            <div className="searchContainer" ref={searchContainerRef}>
                <FaSearch className="searchIcon" />
                <input
                    type="text"
                    placeholder={isCategory ? 'Search categories...' : 'What services do you need today'}
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                />
                {enableFilters && (
                    <button className="filterBtn" onClick={() => setShowFilters(!showFilters)}>
                        Filter <FaFilter />
                        {appliedFiltersCount > 0 && (
                            <span className="filterBadge">{appliedFiltersCount}</span>
                        )}
                    </button>
                )}
                <button className="searchBtn" onClick={handleSearchClick}>
                    Search
                </button>
                {showFilters && enableFilters && (
                    <FilterDropdown
                        filters={filters}
                        setFilters={setFilters}
                        categories={categories}
                        onClose={() => setShowFilters(false)}
                    />
                )}
                {isCategory && suggestions.length > 0 && (
                    <div className="suggestions">
                        {suggestions.map((suggestion, index) => (
                            <div
                                key={index}
                                className="suggestion"
                                onClick={() => handleSuggestionClick(suggestion)}
                            >
                                {suggestion.type === 'main' ? (
                                    suggestion.name
                                ) : (
                                    <span>
                                        {suggestion.sub} <span style={{ fontWeight: 'bold' }}>in</span> {suggestion.main}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchBar;